function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/~/@babel/runtime/helpers/iterableToArray.js
// module id = 1052
// module chunks = 0